import React, { ReactElement } from 'react';
import CardHeaderInternal from '@mui/material/CardHeader';
import ImageAvatar from '../image-avatar/image-avatar.component';
import FormatService from '../../services/format-service';
import useStylesCardHeader from './card-header.styles';

const CardHeader: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isLight,
    headerTitle,
    headerSubTitle,
    imageLink,
    className,
    headerTitleClassName,
    headerSubTitleClassName,
    imageClassName,
    imageAvatarClassName,
    actionClassName,
    headerComponent,
    actionComponent,
  } = props;

  const { classes } = useStylesCardHeader();

  const headerSubTitleLightClassName: string | undefined = isLight ? classes.cardHeaderSubTitleLight : undefined;

  return (
    <CardHeaderInternal
      avatar={!!imageLink && !headerComponent && (
        <ImageAvatar
          text={headerTitle}
          link={imageLink}
          className={imageClassName}
        />
      )}
      title={headerComponent || headerTitle}
      subheader={headerSubTitle}
      action={actionComponent}
      classes={{
        root: className,
        title: headerTitleClassName,
        subheader: FormatService.formatClassNames(headerSubTitleLightClassName, headerSubTitleClassName),
        avatar: imageAvatarClassName,
        action: actionClassName,
      }}
    />
  );
});

export default CardHeader;
